import { Grid, Box, Typography } from "@mui/material";

export const CardAlertsMessages = ({
  messages,
  isFirst,
}: {
  messages: string[];
  isFirst?: boolean;
}) => {
  const MessageItem = ({ message, mb }: { message: string; mb?: string }) => (
    <Grid
      item
      xs={12}
      sx={{
        bgcolor: "#ff6c6c",
        borderRadius: "8px",
        p: 1,
        mb: mb || "6px",
      }}
    >
      <Typography sx={{ color: "white", fontSize: "12px" }}>
        {message}
      </Typography>
    </Grid>
  );
  if (!messages?.length) return null;

  return (
    <Box sx={{ mb: 2 }}>
      {isFirst ? (
        <MessageItem message={messages[0]} mb="6px" />
      ) : (
        messages.map((message) => (
          <MessageItem key={message} message={message} />
        ))
      )}
    </Box>
  );
};
